/**
 * Handles toggling the main navigation menu for small screens.
 */
jQuery( document ).ready( function( $ ) {
	var $masthead = $( '#masthead' ),
	    timeout = false;
		
	$masthead.find( '.main-navigation' ).addClass( 'visible' );

	$.fn.smallMenu = function() {
		$masthead.find( '#site-navigation' ).removeClass( 'main-navigation' ).addClass( 'main-small-navigation' );
		$masthead.find( '#site-navigation h3' ).removeClass( 'assistive-text' ).addClass( 'menu-toggle' );

		$( '.menu-toggle' ).unbind( 'click' ).click( function() {
			const $menuContainer = $masthead.find( '.menu-main-menu-container' );
						
			$menuContainer.toggleClass( 'toggled-on' );
			$( this ).toggleClass( 'toggled-on' );
			
			const isOpen = $menuContainer.hasClass('toggled-on');
			
			// 🚫 Prevent body from scrolling when menu is open
			if (isOpen && isSmallMenu) 
			{
				$('html, body').addClass('no-scroll');
			} 
			else 
			{
				$('html, body').removeClass('no-scroll');
			}
		} );
	};

	// Check viewport width on first load.
	if ( $( window ).width() < 900 )
		$.fn.smallMenu();

	// Check viewport width when user resizes the browser window.
	$( window ).resize( function() {
		var browserWidth = $( window ).width();

		if ( false !== timeout )
			clearTimeout( timeout );

		timeout = setTimeout( function() {
			if ( browserWidth < 900 ) {
				$.fn.smallMenu();
			} else {
				$masthead.find( '#site-navigation' ).removeClass( 'main-small-navigation' ).addClass( 'main-navigation' );
				$masthead.find( '#site-navigation h3' ).removeClass( 'menu-toggle' ).addClass( 'assistive-text' );
				
				// 👇 Ensure scroll is restored when menu is not in small mode
				$('html, body').removeClass('no-scroll');
			}
		}, 200 );
	} );
	
	/* Image anomation */
	const images = document.querySelectorAll(".animate");

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-inViewport");
                observer.unobserve(entry.target); // Stop observing once zoom is triggered
            }
        });
    }, {
        threshold: 0.2 // Trigger when 20% of the element is visible
    });

    images.forEach(image => {
        observer.observe(image);
    });
} );

document.addEventListener("DOMContentLoaded", function () {
	
  // Hide read-more if content isn't overflowing
  const bdMaxHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--service-description-max-height')
  );

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      const desc = entry.target;
      const readMore = desc.querySelector(".read-more");
	  
      if (readMore && desc.scrollHeight <= bdMaxHeight) {
        readMore.style.display = "none";
      }
      observer.unobserve(desc); // only need to check once
    });
  });

  document.querySelectorAll(".block-description").forEach(function(desc) {
    observer.observe(desc);
  });
  
  // Select all .read-more links inside .block-description
  document.querySelectorAll(".read-more a").forEach(function(link) {
	  
    link.addEventListener("click", function(e) {
      e.preventDefault();

      const desc = link.closest('.wp-block-column').querySelector('.block-description');

      // Toggle the .expanded class
      desc.classList.toggle("expanded");
	  const icon = link.querySelector("i");
	  icon.classList.toggle("fa-compress");
	  icon.classList.toggle("fa-expand");
    });
  });
});
